import { render } from "./SearchHeader.vue?vue&type=template&id=174915d6&scoped=true"
import script from "./SearchHeader.vue?vue&type=script&lang=js"
export * from "./SearchHeader.vue?vue&type=script&lang=js"

import "./SearchHeader.vue?vue&type=style&index=0&id=174915d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174915d6"]])

export default __exports__